import { render, staticRenderFns } from "./AddCustomer.vue?vue&type=template&id=1ec8bc56&scoped=true"
import script from "./AddCustomer.vue?vue&type=script&lang=ts"
export * from "./AddCustomer.vue?vue&type=script&lang=ts"
import style0 from "./AddCustomer.vue?vue&type=style&index=0&id=1ec8bc56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec8bc56",
  null
  
)

export default component.exports